import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import rightarrowicon from './../../Assets/icons/chevron-right.svg';
import downarrowicon from './../../Assets/icons/chevron-down.svg';
// import dmsLogo from './../../Assets/icons/logo.svg';
import rectangleLogo  from "./../../Assets/icons/logo-newtron-green.svg" 
import "./index.scss";

const SidePanel = ({ card_id, menuData }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [expandedMenuId, setExpandedMenuId] = useState(null); // Stores the currently expanded menu's ID
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();
  const location = useLocation();
  console.log("menuData>>", menuData);

  const toggleSubmenu = (menuId) => {   
    setExpandedMenuId((prevMenuId) =>
      prevMenuId === menuId ? null : menuId
    );
  };

  const extractFileName = (path) => {
    const parts = path.split('/');
    return parts[parts.length - 1];
  };

  const handleItemClick = (url) => {
    navigate(`/${url}`);
  };

  const isItemActive = (url) => {
    return location.pathname === `/${url}`;
  };

  const isParentActive = (items) => {
    return items.some((item) => {
      const url = item.parentUrl || item.childUrl || item.subchildUrl;
      if (isItemActive(url)) {
        return true;
      }
      if (item.children && item.children.length > 0) {
        return isParentActive(item.children);
      }
      return false;
    });
  };

  const renderMenuItems = (items) => {
    if (!Array.isArray(items)) return null;

    return (
      <div>
        {items.filter(item => item.parentMenuIsActive !== false).map((item) => {
          const id = item.parentId || item.childId || item.subchildId;
          const url = item.parentUrl || item.childUrl || item.subchildUrl;
          const name = item.parentMenuName || item.childMenuName || item.subchildMenuName;
          const icon = item.parentMenuIcon || item.childMenuIcon || item.subchildMenuIcon;
          const isActive = isItemActive(url);
          const isParent = item.children && item.children.length > 0;

          const activeChildren = item.children ? item.children.filter(child => child.childMenuIsActive !== false) : [];
          const hasActiveChildren = activeChildren.length > 0;

          if (isParent && !hasActiveChildren) {
            return null;
          }

          const isParentActiveClass = isParent && isParentActive(activeChildren) ? "active" : "";

          return (
            <div key={id} className={`nav-item ${isParentActiveClass}`}>
              <div
                className={`nav-link ${isActive ? "active" : ""}`}
                style={{ backgroundColor: isActive ? "#FFFFFF33" : "" }}
                onClick={() => {
                  if (isParent) {
                    toggleSubmenu(id);
                  } else {
                    handleItemClick(url);
                  }
                }}
              >
                {icon ? (
                  <div className="leftmenuiconcontainer">
                    <img
                      src={icon}
                      alt={name}
                      className="nav-icon"
                    />
                  </div>
                ) : (
                  <span className="nav-icon-placeholder" />
                )}
                {isExpanded && <span className="nav-title">{name}</span>}
                {isExpanded && isParent && (
                  <span className="submenu-toggle-icon">
                    {expandedMenuId === id ? <img src={downarrowicon} alt="icon" /> : <img src={rightarrowicon} alt="lefticon" />}
                  </span>
                )}
              </div>
              {isExpanded && expandedMenuId === id && isParent && (
                <div className="flex-column sub-menu">
                  <ul className="childSubMenu">
                    {renderMenuItems(activeChildren)}
                  </ul>
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };


  return (
    <>
      <div style={{ backgroundColor: '#1d1b20', padding: "0px 0px", cursor: 'pointer', position: "fixed", zIndex: "10", width: "15%", borderBottom: "1px solid rgba(207, 250, 200, 0.3)" }} onClick={() => navigate('/cards')}>
        <div style={{width:"100%", display:"flex", justifyContent:"center", alignItems:"center"}}>
        <img src={rectangleLogo} alt="home" style={{width:"76%", paddingTop:"25px"}} />
        </div>
        <div style={{fontSize:"26px", padding:"15px"}} className="ParentTitle">
          {menuData[0]?.parentTitle}
          </div>
      </div>
      <div className={`side-panel ${isExpanded ? "expanded" : ""}`}>
        <div className="flex-column">
          {renderMenuItems(menuData)}
        </div>
      </div>
    </>
  );
};

export default SidePanel;
